export default __webpack_public_path__ + "static/media/upArrow.ffeea463.svg";